/**
 * RAV4 단독 뷰어 엔트리. 셸/도구는 createViewer + TOOLS 레지스트리로 이관됨.
 * 차종 차이는 cars/rav4.ts (config) + RAV4_HDRI_MAP.
 */
import { createViewer } from './viewer/createViewer.js';
import { RAV4, RAV4_HDRI_MAP } from './viewer/cars/rav4.js';

createViewer(RAV4, RAV4_HDRI_MAP).catch((err) => {
  console.error('[test-rav4] init failed:', err);
  const el = document.getElementById('splash-error');
  if (el) el.textContent = 'ERROR — see console';
});
